import styled from "@emotion/styled"
import { ListItem, Text } from "@chakra-ui/react"

export const Header = styled.h1`
  font-size: 32px;
  font-family: Gotham A, Gotham B, sans-serif;
  line-height: 150%;
  font-style: normal;
  font-weight: normal;
`

export const SubHeader = styled.h2`
  font-size: 18px;
  font-family: Gotham A, Gotham B, sans-serif;
  line-height: 150%;
  font-style: normal;
  font-weight: normal;
`

export const Question = styled.h3`
  font-size: 18px;
  font-family: Gotham A, Gotham B, sans-serif;
  line-height: 150%;
  font-style: normal;
  font-weight: 700;
  margin-top: 18px;
`

export const DidYouContainer = styled.div`
  margin-top: 47px;
  margin-bottom: 14px;
`

export const DidYou = styled(Text)`
  font-size: 14px;
  font-family: Gotham A, Gotham B, sans-serif;
  font-weight: 600;
  font-style: italic;
`

export const DidYouItem = styled(ListItem)`
  font-size: 14px;
  line-height: 22px;
  margin-left: 4px;
  font-family: Gotham A, Gotham B, sans-serif;
  font-style: italic;
`

export const MemberIndicatedFollowingContainer = styled.div`
  background-color: #f1de7a;
  border: 2px solid #f1bf0b;
  border-radius: 8px;
  padding: 16px;
  margin-top: 25px;
  margin-bottom: 25px;
`

export const MemberIndicatedHeader = styled.h3`
  font-size: 16px;
  font-family: Gotham A, Gotham B, sans-serif;
  font-weight: 700;
`

export const MemberIndicatedListItem = styled.li`
  list-style: disc;
  margin-left: 32px;
`
